var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"params-sheet",attrs:{"color":"grey lighten-4"}},[_vm._l((_vm.items),function(ref,index){
var name = ref.name;
var value = ref.value;
return [_c('span',{key:index,staticClass:"params-sheet__item"},[_c('span',{staticClass:"params-sheet__item-name"},[_vm._v(_vm._s(name)+":")]),_c('span',{staticClass:"params-sheet__value"},[_vm._v(_vm._s(value))])])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }